import * as React from "react";
import "./index.scss";
import {imageBaseUrl} from "config";

interface IProps {
    primaryText: string;
    secondaryText?: string;
    onClick: () => void;
    icon?: string;
}

export const OptionCard = (props: IProps) => {
    return (
        <div className="option-card" onClick={() => props.onClick()}>
            <div className="content-container">
                <div className="text-box">
                    <div className="primary-text">
                        {props.primaryText}
                    </div>
                    {props.secondaryText ?
                        <div className="secondary-text">
                            {props.secondaryText}
                        </div> : null}
                </div>
                <div className="icon">
                    <img src={`${props.icon ? props.icon : `${imageBaseUrl}/img/consent/option_card_circle.png`}`} alt="click here"/>
                </div>
            </div>
        </div>
    );
};

export default OptionCard;
